/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Image_AltInputs */

const en_gc_resources_download_image_alt = /** @type {(inputs: Gc_Resources_Download_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft desktop spreadsheet interface`)
};

const zh_gc_resources_download_image_alt = /** @type {(inputs: Gc_Resources_Download_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 桌面电子表格界面`)
};

/**
* | output |
* | --- |
* | "GridCraft desktop spreadsheet interface" |
*
* @param {Gc_Resources_Download_Image_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_image_alt = /** @type {((inputs?: Gc_Resources_Download_Image_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Image_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_image_alt(inputs)
	return zh_gc_resources_download_image_alt(inputs)
});
export { gc_resources_download_image_alt as "gc.resources.download.image_alt" }